import { data } from 'autoprefixer';
import { PROJECT_TYPES } from '../actions/projectActions';

// Helper functions to handle localStorage
const saveToLocalStorage = (state) => {
  try {
    localStorage.setItem('projectState', JSON.stringify(state));
  } catch (error) {
    console.error('Failed to save state to localStorage:', error);
  }
};

const loadFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem('projectState');
    return serializedState ? JSON.parse(serializedState) : undefined;
  } catch (error) {
    console.error('Failed to load state from localStorage:', error);
    return undefined;
  }
};

const initialState = loadFromLocalStorage() || {
  project: {},
  parts: [],
};

const projectReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case PROJECT_TYPES.SAVE_PROJECT_DETAILS:
      newState = {
        ...state,
        project: action.payload.project,
        parts: action.payload.parts,
      };
      break;

    case PROJECT_TYPES.CLEAR_PROJECT_DETAILS:
      newState = {
        ...state,
        project: {},
        parts: [],
      };
      break;

    default:
      newState = state;
  }

  saveToLocalStorage(newState);
  return newState;
};
export default projectReducer;
